import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Row, Col, Button } from "reactstrap";

const messages = {
  401: {
    title: "Unauthorized",
    description: "You are not authorized to view this page. Please login again.",
    actionLabel: "Go to Login",
  },
  403: {
    title: "Forbidden",
    description: "You don’t have permission to access this resource.",
    actionLabel: "Go to Login",
  },
  404: {
    title: "Page Not Found",
    description: "The page you’re looking for doesn’t exist or has been moved.",
    actionLabel: "Go to Login",
  },
  500: {
    title: "Internal Server Error",
    description: "Something went wrong on our end. Please try again later.",
    actionLabel: "Go to Login",
  },
  network: {
    title: "Something went wrong on our end. Please try again later`",
    description: "Unable to connect to the server. Please check your connection or try again later.",
    actionLabel: "Go to Login",
  },
  unexpected: {
    title: "Unexpected Error",
    description: "An unknown error occurred. Please try again later.",
    // no actionLabel here
  },
};

const ErrorPage = () => {
  const { code } = useParams();
  const navigate = useNavigate();

  const error = messages[code] || messages.unexpected;

  return (
    <Container className="d-flex align-items-center justify-content-center vh-100">
      <Row className="w-100">
        <Col className="text-center">
          <h1 className="display-1 fw-bold text-danger">{code}</h1>
          <h2 className="fw-semibold mb-3">{error.title}</h2>
          <p className="text-muted mb-4">{error.description}</p>

          {/* Only show button if actionLabel exists */}
          {error.actionLabel && (
            <Button
              color="primary"
              onClick={() => navigate("/login")}
              className="px-4"
            >
              {error.actionLabel}
            </Button>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default ErrorPage;
